import { addDoc, collection, getDocs, limit, orderBy, query, serverTimestamp, where } from "firebase/firestore";
import { ACTIONS } from "../constants/actions";
import { db } from "./firebase";

export async function writeLog(actor, action, targetType, targetId, targetLabel, metadata = {}) {
  if (!actor?.uid) return;
  await addDoc(collection(db, "auditLogs"), {
    uid: actor.uid,
    userEmail: actor.email || "",
    userName: actor.displayName || "",
    action,
    targetType,
    targetId,
    targetLabel,
    metadata,
    timestamp: serverTimestamp(),
  });
}

export async function getRecentActivity(max = 10) {
  const q = query(collection(db, "auditLogs"), orderBy("timestamp", "desc"), limit(max));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function queryAuditLogs({ action, from, to }) {
  const clauses = [];
  if (action) clauses.push(where("action", "==", action));
  if (from) clauses.push(where("timestamp", ">=", new Date(from)));
  if (to) clauses.push(where("timestamp", "<=", new Date(`${to}T23:59:59`)));
  const q = query(collection(db, "auditLogs"), ...clauses, orderBy("timestamp", "desc"), limit(200));
  const snap = await getDocs(q);
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export { ACTIONS };
